import { ChamberService } from '../entities/ChamberService'
import { ChamberCategory } from '../entities/ChamberCategory'
import { pksApiService } from '../services/pksApiService'
import { PKS_SERVICES } from '../config/pks-constants'

const includeFields = ['id', 'service_slug', 'services', 'link']
    .map(field => `include[]=${field}`)
    .join('&')

class ServicesCommunicator {
    async fetchAllChamberServices(offset = null) {
        const params = {
            offset
        }

        const allChamberServices = await pksApiService.fetchData(
            `/chamber-services?${includeFields}`,
            params
        )
        return allChamberServices.map(item => new ChamberService(item))
    }

    async fetchHomepageChamberServices() {
        const params = {
            offset: 4,
            category_id: 1
        }

        const allChamberServices = await pksApiService.fetchData(
            `/chamber-services?${includeFields}`,
            params
        )
        return allChamberServices.map(item => new ChamberService(item))
    }

    async fetchSingleService(slug) {
        const singleServiceEndpoint = `/chamber-services/${slug}`
        const singleService = await pksApiService.fetchData(singleServiceEndpoint)

        return new ChamberService(singleService)
    }

    async fetchServicesByCategories() {
        const chamberServices = await pksApiService.fetchData(
            `/chamber-services?category_id=${PKS_SERVICES.SERVICES_BY_CATEGORIES}`
        )

        return chamberServices.map(item => new ChamberService(item))
    }

    async fetchChamberServiceCategories() {
        const chamberServiceCategories = await pksApiService.fetchData(
            '/chamber-service-categories'
        )

        return chamberServiceCategories.map(item => new ChamberCategory(item))
    }

    fetch(id) {
        return pksApiService
            .fetch('/chamber-services', id)
            .then(chamber => new ChamberService(chamber))
    }

    fetchPage(pageSize = 20, page = 1, queryParams = {}) {
        return pksApiService
            .fetchPage('/chamber-services', pageSize, page, queryParams)
            .then(chambersList => chambersList.map(item => new ChamberService(item)))
    }

    fetchAllCategories() {
        return pksApiService
            .fetchPage('/chamber-service-categories')
            .then(chambersCategories => chambersCategories.map(item => new ChamberCategory(item)))
    }
}

export const servicesCommunicator = new ServicesCommunicator()
